export const getTomorrowDate = (date?: Date) => {
  const today = date ? new Date(date) : new Date();
  today.setDate(today.getDate() + 1);
  return today;
};

export const getDateWithoutTime = (date: Date) => {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate());
};
